import { render } from "./myHeader.vue?vue&type=template&id=7065fd3e&scoped=true"
import script from "./myHeader.vue?vue&type=script&lang=js"
export * from "./myHeader.vue?vue&type=script&lang=js"

import "./myHeader.vue?vue&type=style&index=0&id=7065fd3e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7065fd3e"]])

export default __exports__